import React from 'react';

const MapPointerIcon = () => (
    <svg className="svg-icon map-pointer-icon" width="16px" height="20px" viewBox="5 3 16 20"
        xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g className="theme-path" fillRule="evenodd" transform="translate(0.000000, 0.000000)">
            <path d="M5.00000054,11.002984 C5.00000018,11.0019894 5,11.0009947 5,11 C5,6.581722 8.581722,3 13,
            3 C17.418278,3 21,6.581722 21,11 C21,11.0004974 21,11.0009947 20.9999999,11.001492 C20.999438,
            15.9038378 18.2294502,20.3852749 13.8445825,22.5777088 L13,23 L12.1554175,22.5777088 C7.77099462,
            20.3854973 5.00112405,15.9047471 5.00000034,11.002984 Z M13,14 C14.6568542,14 16,12.6568542 16,11 C16,
            9.34314575 14.6568542,8 13,8 C11.3431458,8 10,9.34314575 10,11 C10,12.6568542 11.3431458,14 13,14 Z">
            </path>
        </g>
    </svg>
);

export default MapPointerIcon;
